import request from '@/utils/requests'

/**
 * 生成钱包登录签名串
 * @returns 
 */
// export const requestUserProfile = () => {
//     return request({
//         url: '/user/profile',
//         method: 'get'
//     })
// }
export const requestUserProfile = () => {
    return request({
        url: 'https://stake-api.metaflow.club/app-api/user/profile',
        method: 'get'
    })
}